import replace from 'lodash/replace'

export default (date) => replace(date, /-/g, '.')